module.exports = __webpack_public_path__ + "img/smithfield-city-logo.d8ae5d98.jpg";